import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import './pages.css';

const AboutUs = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="gpt3__pages gradient__bg">
            <div className="gpt3__pages-back">
                <Link to="/">
                    <FiArrowLeft /> Back to Home
                </Link>
            </div>
            <div className="gpt3__pages-content">
                <h1 className="gradient__text">About Prinzetuner</h1>
                <p>Advanced ECU Solutions for Professionals.</p>
                
                <h2>Our Mission</h2>
                <p>Prinzetuner is a specialized automotive tuning platform dedicated to providing high-quality ECU file processing and custom software solutions. We focus on advanced IMMO OFF, system-level modifications, and binary structure analysis for the professional tuner.</p>
                
                <h2>Expertise</h2>
                <p>With years of experience in ECU reverse engineering and software development, we specialize in a wide range of ECU families including Hitachi, Denso, SIM2K, and CPEG series for manufacturers like Nissan, Kia, and Hyundai.</p>
                
                <h2>Reliability & Precision</h2>
                <p>Our tools are built for accuracy and stability. Every modification is carefully processed with checksum correction and structural awareness to ensure safe and reliable ECU file rebuilding.</p>
                
                <h2>Global Reach</h2>
                <p>Based in Saudi Arabia, we provide our services and support to professional tuners worldwide, helping them unlock the full potential of automotive control units.</p>
            </div>
        </div>
    );
};

export default AboutUs;
